






















































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import SwiperNews from "@/zh-website/src/components/website/Swiper/SwiperNews.vue";
import SwiperReport from "@/zh-website/src/components/website/Swiper/SwiperReport.vue";
import { NewsService } from "@/zh-website/src/views/Content/service/newsService";
import Report from "@/zh-website/src/components/website/Report.vue";
@Component({
  components: {
    SwiperNews,
    SwiperReport,
    Report
  }
})
export default class Index extends Vue {
  lately: any = [];
  report: any = [];
  rightNew: any = [];
  leftNew: any = {};
  reportData:any={}
  showImg = true;
  newjump = "/home/news/det/";
  url = "https://www.zj-huawei.com";
  mounted() {
    this._getRightNew();
    this.getReport()
    //专题报导
    this.$nextTick(()=>{
      if(this.$route.query.target){
        (this.$refs.targetLocation as any).scrollIntoView()
      }
    })
  }

  //右侧新闻动态
  async _getRightNew() {
    NewsService.getNewsList({ pageNum: 1, pageSize: 5, timeFrameCode: 1 }).then(
      (res: any) => {
        if (res.data.list.length > 0) {
          this.leftNew = res.data.list[0];
          this.rightNew = res.data.list.slice(1, res.data.list.length);
        } else {
          this.leftNew = {};
          this.rightNew = [];
        }
      }
    );
  }
  async getReport(){
    NewsService.getReportList({
        pageNum: 1,
        pageSize: 1,
        timeFrameCode: ''
      }).then((res: any) => {
       if(res.success){
        this.reportData=res.data.list[0]
       }
      });
  }
}
